import { createContext } from 'react';

export const NetworkStatusValuesContext = createContext({});

export default NetworkStatusValuesContext;
